'use strict';

import React from "react";
import Moment from "moment";

export default class MessageStandAlone extends React.Component {
    render() {
        let side = "lv-item media left";
        let sideAvatar = "lv-avatar pull-left";
        if (this.props.sender == "admin"){
            side = "lv-item media right";
            sideAvatar = "lv-avatar pull-right";
        }
        return (
            <div className={side}>
                <div className={sideAvatar}>
                    <img src="" alt=""/>
                </div>
                <div className="media-body">
                    <div className="ms-item">
                        {this.props.Message}
                    </div>
                    <small className="ms-date">
                        <i className="zmdi zmdi-access-time"></i>
                        {this.props.messageTime}</small>
                </div>
            </div>
        )
    }

}

//module.exports = MessageStandAlone;
